// ENP2019
export const onboardingVehicle: any = {
  number_plate: 'ENP2019',
  latest_tracker_log: {
    id: 132793,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7624633, -33.4925316],
    },
    properties: {
      vehicle: 'ENP2019',
      samples: [
        {
          id: 354850,
          value: '38.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 132793,
        },
        {
          id: 354850,
          value: '16842750.000',
          source: 'IO-data',
          measurand: 'Odometer',
          log: 132793,
        },
        {
          id: 354850,
          value: '80.000',
          source: 'IO-data',
          measurand: 'SOC',
          log: 132793,
        },
      ],
      timestamp: new Date(),
      altitude: '470.90',
      angle: '267.4',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 555,
    },
  },
  latest_transaction: {
    id: 430,
    reservation_id: null,
    id_tag_start: '123456789',
    id_tag_stop: '123456789',
    meter_start: 386439,
    meter_stop: 386559,
    timestamp_start: '2023-03-09T19:08:05.741914',
    timestamp_stop: '2023-03-09T19:08:27.960293',
    reason_stop: 'Local',
    soc_start: 1,
    soc_stop: 3,
    cost: 10,
    price: 25,
    max_power: '88687.00',
    avg_power: '66515.25',
    total_energy: 120,
    soh: 89,
    odometer: null,
    remaining_time: '0.22',
    connector: 37,
    user_start: null,
    user_stop: null,
    vehicle: 'ENP2019',
  },
  verbose_name: 'Furgolink',
  vin: '123456789',
  vin2: null,
  brand: 'Peugeot',
  model: 'Partner HID 2022',
  class_type: 'Van',
  nominal_range: 0,
  consumption: 0,
  battery_nominal_capacity: 100000,
  co2eqIC: 0,
  vin_as_id_tag: true,
  latest_soc: '80.000',
  latest_odometer: '1000.000',
  latest_remaing_km: '190.000',
  latest_temperature: '200.000',
  status: 'Online',
  created: '2022-09-27T14:06:45.401679',
  updated: '2023-02-10T15:00:58.797352',
  fleet: 4,
};
